import { Flex } from '@aloft/toolkit-sui';

import { selectMainDwellingCostsCommentaryDisplay } from '../../../redux/features/selectors/commentarySelectors/selectMainDwellingCostsCommentary.ts';
import { useAppSelector } from '../../../redux/hooks.ts';
import { Typography } from '../../../summary/components/Typography.tsx';
import { CommentarySubSection } from '../components/CommentarySubsection.tsx';
import { CostBreakdownRow } from '../components/CostBreakdownRow.tsx';
import { COMMENTARY_TEXT } from '../consts.ts';
import { selectSubjectPropertyType } from '../../../redux/features/selectors/selectSubjectPropertyType.ts';

const { subtitle } = COMMENTARY_TEXT['dep-cost'].subItems['main-dwelling'];

export const MainDwelling = () => {
  const propertyType = useAppSelector((state) => selectSubjectPropertyType(state));
  const title = propertyType === 'multiFamily' ? 'Dwelling' : 'Main Dwelling';
  const data = useAppSelector((state) => selectMainDwellingCostsCommentaryDisplay(state));

  return (
    <CommentarySubSection title={title} subtitle={subtitle}>
      <Flex flexDirection="column" gap={4}>
        <CostBreakdownRow {...data.gla} />
        <CostBreakdownRow {...data.fullBath} />
        <CostBreakdownRow {...data.halfBath} />
        {data.basementTotal && <CostBreakdownRow {...data.basementTotal} />}
        {data.basementFinished && <CostBreakdownRow {...data.basementFinished} />}
        {data.units && <CostBreakdownRow {...data.units} />}

        {data.roundingAndThresholds.length > 0 && (
          <Flex flexDirection="column" gap={1}>
            <Typography variant="h5">Rounding & Thresholds</Typography>
            {data.roundingAndThresholds.map((item) => (
              <Typography key={item} variant="body2">
                {item}
              </Typography>
            ))}
          </Flex>
        )}
      </Flex>
    </CommentarySubSection>
  );
};
